import companyUserCompanyBrandPlan from '../api/index'

const Commit = (query) => {
    return new Promise((resolve) => {
        resolve(companyUserCompanyBrandPlan.companyUserCompanyBrandPlan.Commit(query))
    })
}

export default {
    namespaced: true,
    state: {
        companyUserCompanyBrandPlans: null,
    },
    getters: {
        GET_COMPANY_USER_COMPANY_BRAND_PLANS(state) {
            return state.companyUserCompanyBrandPlans;
        },
    },
    mutations: {
        SET_COMPANY_USER_COMPANY_BRAND_PLANS(state, payload) {
            state.companyUserCompanyBrandPlans = payload;
        },
    },
    actions: {
        async COMMIT_FROM_API({ commit }, payload) {
            await Commit(payload).then(
                ({
                    data, status
                }) => {
                    if (status === 200) {
                        if(data.succeeded)                        
                            commit('SET_COMPANY_USER_COMPANY_BRAND_PLANS', data);                   
                    }
                }
            )
            .catch(() => {
                commit('SET_COMPANY_USER_COMPANY_BRAND_PLANS', { succeeded: false });
            })
        },
    }
}
